import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { SessionService } from './services/session.service';

const routes: Routes = [
  // Rota raiz → landing pública
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  // Landing page pública (Google OAuth App Homepage)
  {
    path: 'home',
    loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingPageModule)
  },
  // Auth
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
    canActivate: [SessionService]
  },
  // Sistema protegido
  {
    path: 'account',
    loadChildren: () => import('./pages/account/account.module').then(m => m.AccountPageModule),
  },
  {
    path: 'contact',
    loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactPageModule),
  },
  {
    path: '',
    loadChildren: () => import('./system/system.module').then(m => m.SystemPageModule),
    canActivate: [SessionService]
  },
  // Fallback
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
